import React from 'react'

//component
import Searchbar from './SearchBar'
import APIData from './APIData'

const Products = () => {
    return (
        <div>
            <Searchbar />
            <APIData />
        </div>
    )
}

export default Products